import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';

const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const FeatureUtil = require('../../../../app/shared/FeatureUtil');
import Navigator from '../../Navigator';
import MainNav from '../DashboardNew/Menu/MainNav';
import SubNav from '../nav/SubNav';
import BackButton from '../nav/BackButton';
import ActivityMetaTagsEditor from './ActivityMetaTagsEditor';
import WithActivityData from '../DataHOCs/WithActivityData';
import WithChannelData from '../DataHOCs/WithChannelData';
import WithProjectData from '../DataHOCs/WithProjectData';
import WithOrganizationActivityMetaTagsViaActivity from '../DataHOCs/WithOrganizationActivityMetaTagsViaActivity';

const propTypes = {
    match: PropTypes.shape({
        params: PropTypes.object.isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired,
    activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    activityStoreState: PropTypes.shape({ activity: PropTypes.object }).isRequired,
    projectStoreState: PropTypes.shape({ project: PropTypes.object.isRequired }).isRequired,
    channelStoreState: PropTypes.shape({ channel: PropTypes.object.isRequired }).isRequired,
    orgActMetaTags: PropTypes.object.isRequired,
    actMetaTagCategories: PropTypes.object.isRequired,
    orgActMetaTypes: PropTypes.array.isRequired,
};

const defaultProps = {};

class ActivityMetaTagsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.backHandler = this.backHandler.bind(this);
    }

    componentDidMount() {
        if (
            !FeatureUtil.hasActivityMetaTags(this.props.channelStoreState.channel.channel_permissions)
            || !PermissionsUtil.canViewActMetaTagsForAct(
                this.props.channelStoreState.channel.user_permissions,
                this.props.projectStoreState.project.user_permissions
            )
        ) {
            this.backHandler();
        }
    }

    backHandler() {
        Navigator.goToActivityView(this.props.history, this.props.channelId, this.props.projectId, this.props.activityId)
    }

    render() {
        const canEdit = PermissionsUtil.canManageActMetaTagsForAct(
                this.props.channelStoreState.channel.user_permissions,
                this.props.projectStoreState.project.user_permissions
            );

        return (
            <div>
                <MainNav
                    onClickBrandLogo={() => Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, this.props.channelId)}
                />

                <div className="container main-container">
                    <SubNav menuClasses= "d-inline-block d-sm-none">
                        <BackButton backHandler={this.backHandler} />
                        <div className="view-info-container">
                            <div className="view-title">
                                {this.props.activityStoreState.activity.meta_data.title}
                            </div>
                            <div className="view-description">
                                Manage Activity Meta Tags
                            </div>
                        </div>
                    </SubNav>

                    <Row className="main-content-nav">
                        <div className="main-content col-12">
                            <ActivityMetaTagsEditor
                                className="padding-t-lg"
                                channelId={this.props.channelStoreState.channel.id}
                                projectId={this.props.projectStoreState.project.id}
                                activityId={this.props.activityId}
                                canEdit={canEdit}
                                orgActMetaTags={this.props.orgActMetaTags}
                                actMetaTagCategories={this.props.actMetaTagCategories}
                                orgActMetaTypes={this.props.orgActMetaTypes}
                            />
                        </div>
                    </Row>
                </div>
            </div>
        );
    }
}

ActivityMetaTagsView.propTypes = propTypes;
ActivityMetaTagsView.defaultProps = defaultProps;

const WrappedComponent = withRouter(
    WithActivityData(
        WithChannelData(
            WithProjectData(
                WithOrganizationActivityMetaTagsViaActivity(
                    ActivityMetaTagsView
                )
            )
        )
    )
);

// WithActivityData is expected the activityId prop. "Rename" props.params.activityID to props.activityId here. do the same with projectId & channelId
function WrappedComponentWithUpdatedPropNames(props) {
    return (
        <WrappedComponent
            {...props}
            activityId={props.match.params.activityId}
            projectId={props.match.params.projectID}
            channelId={props.match.params.channel}
            orgId={props.match.params.channel}
        />
    );
}

WrappedComponentWithUpdatedPropNames.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            channel: PropTypes.string.isRequired,
            projectID: PropTypes.string.isRequired,
            activityId: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

export default WrappedComponentWithUpdatedPropNames;